import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconBulletListSvg } from "./IconBulletListSvg.mjs";
const IconBulletList = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconBulletListSvg, ...svgProps }) });
export {
  IconBulletList
};
